import { View } from 'react-native';

export const NotFoundScreen = () => <View />;
